import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
import { fromPrice, hasRange } from '../../utils/products';
import type { Product } from '../../types/product';
import { Stars } from './Stars';
const badgeLabel: Record<string, string> = {
  bestseller: 'Bestseller',
  nieuw: 'Nieuw',
  cadeau: 'Cadeau'
};
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const {
    add
  } = useCart();
  const first = product.variants[0];
  const badge = product.badges[0];
  return <article className="group relative flex h-full flex-col" data-id="element-328" data-mp="272ravkcxvljt">
      <div className="relative overflow-hidden rounded-3xl bg-surface" data-id="element-329" data-mp="223erj9la0wlz">
        <Link to={`/product/${product.slug}`} aria-label={product.name} data-id="element-330" data-mp="2247ndfip61pc">
          <img src={product.image} alt="" className="aspect-[4/5] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-331" data-mp="cp9lrswvygmo" />
          {product.gallery[1] && <img src={product.gallery[1]} alt="" className="absolute inset-0 h-full w-full object-cover object-[50%_30%] opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100" data-id="element-332" data-mp="3gq5ihg9g0d68" />}
        </Link>
        {badge && <span className="absolute left-3 top-3 z-10 rounded-full bg-white px-2.5 py-1 text-xs font-medium text-ink" data-id="element-333" data-mp="3viplmgwlekno">
            {badgeLabel[badge]}
          </span>}
        <button type="button" onClick={() => add(product.slug, first.id)} className="absolute bottom-3 right-3 z-10 grid h-11 w-11 place-items-center rounded-full bg-white text-ink shadow-[0_6px_16px_-8px_rgba(28,23,20,0.5)] transition-[background-color,color,transform] duration-150 hover:bg-ink hover:text-white active:scale-95" aria-label={`${product.name} (${first.label}) toevoegen aan winkelwagen`} data-id="element-334" data-mp="8ac3j5urf9ra">
          <PlusIcon className="h-4 w-4" data-id="element-335" data-mp="2c0i881sbkbji" />
        </button>
      </div>
      <div className="flex flex-1 flex-col pt-4" data-id="element-336" data-mp="2c2uugr54182d">
        <Stars rating={product.rating} reviews={product.reviews} data-id="element-337" data-mp="2738jkocr83wq" />
        <h3 className="mt-2 text-base font-semibold tracking-tight text-ink" data-id="element-338" data-mp="2lyxv1skbcyn7">
          <Link to={`/product/${product.slug}`} className="hover:underline hover:underline-offset-4" data-id="element-339" data-mp="2lwv14xg1ild7">
            {product.name}
          </Link>
        </h3>
        <p className="mt-0.5 text-sm text-muted" data-id="element-340" data-mp="2uykxmhos4ahu">{product.subtitle}</p>
        <p className="mt-auto pt-3 text-base font-semibold text-ink" data-id="element-341" data-mp="2q1kuaejbdluf">
          {hasRange(product) && <span className="mr-1 text-sm font-normal text-muted" data-id="element-342" data-mp="34q8ke5ae53cz">vanaf</span>}
          {formatPrice(fromPrice(product))}
          {first.compareAt && <span className="ml-2 text-sm font-normal text-muted line-through" data-id="element-343" data-mp="2zsp8vd52v4oq">{formatPrice(first.compareAt)}</span>}
        </p>
      </div>
    </article>;
}